interface DisclaimerProps {
  title?: JSX.Element | string
  description: JSX.Element | string
  className?: string
  icon?: JSX.Element
  leftFlapVariant?: keyof typeof LEFT_FLAP_COLORS | null
  borderVariant?: keyof typeof BORDER_VARIANTS
  textClassName?: string
}

const LEFT_FLAP_COLORS = {
  yellow: 'bg-[#E8BA38]',
  green: 'bg-[#0EBF2B]',
  blue: 'bg-[#4182DC]',
  red: 'bg-red-900',
  purple: 'bg-purple-900'
}

const BORDER_VARIANTS = {
  none: 'border-none',
  gray: 'border border-gray-500',
  green: 'border shadow-none !bg-[#CFF6E8] border-green-900'
}

const Disclaimer = ({
  description,
  className = '',
  textClassName = '',
  title = null,
  icon = null,
  leftFlapVariant = null,
  borderVariant = 'none'
}: DisclaimerProps) => (
  <div
    className={`bg-white text-black leading-[0.875rem] text-2xs rounded-lg shadow-card-benefits h-full text-left flex w-full ${BORDER_VARIANTS[borderVariant]} ${className}`}
  >
    {leftFlapVariant ? (
      <span
        className={`!min-h-full rounded-l-lg !w-2 ${LEFT_FLAP_COLORS[leftFlapVariant]}`}
      />
    ) : null}
    <div
      className={`p-2 flex items-center justify-between w-full h-full ${textClassName}`}
    >
      <div className='w-full'>
        {title ? <p className='font-bold mb-1'>{title}</p> : null}
        <p className='font-medium'>{description}</p>
      </div>
      {icon ? <div className='w-6 h-6'>{icon}</div> : null}
    </div>
  </div>
)

export default Disclaimer
